var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vip-layout-background",class:_vm.$vuetify.breakpoint.mdAndUp ? 'px-12' : 'px-2'},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }